/**
 * canvas点线动画
 * 用于登录页背景
 */

/* eslint-disable */
export default function () {
    function a(a) {
        return document.getElementsByTagName(a);
    }

    function b(a) {
        return document.getElementById(a);
    }

    function c(c) {
        var g, i, j;
        return c = c || {}, a('html')[0], g = a('body')[0], b('canvas-particle'), i = document.createElement('canvas'), i.setAttribute('id', c.id || 'html5Canvas'), j = {
            element: i,
            points: [],
            config: {
                vx: c.vx || 4,
                vy: c.vy || 4,
                height: c.height || 2,
                width: c.width || 2,
                count: c.count || 100,
                color: c.color || '121, 162, 185',
                stroke: c.stroke || '130,255,255',
                dist: c.dist || 6e3,
                e_dist: c.e_dist || 2e4,
                max_conn: 10
            }
        }, j.element.getContext('2d') ? (j.context = j.element.getContext('2d'), g.style.padding = '0', g.style.margin = '0', g.appendChild(j.element), j.element.style = 'position: absolute; top: 0; left: 0; z-index: -1', d(j.element), window.onresize = function () {
            d(j.element);
        }, g.onmousemove = function (a) {
            var b = a || window.event;
            j.mouse = { x: b.clientX, y: b.clientY };
        }, document.onmouseleave = function () {
            j.mouse = void 0;
        }, setInterval(function () {
            e(j);
        }, 40), void 0) : null;
    }

    function d(a) {
        a.width = window.innerWeight || document.documentElement.clientWidth || document.body.clientWidth, a.height = window.innerWeight || document.documentElement.clientHeight || document.body.clientHeight;
    }

    function e(a) {
        var c, e, h, b = a.context;
        for (b.clearRect(0, 0, a.element.width, a.element.height), b.beginPath(), b.fillStyle = 'rgb(' + a.config.color + ')', e = 0, h = a.config.count; h > e; e++) c = a.points.length != a.config.count ? {
            x: Math.floor(Math.random() * a.element.width),
            y: Math.floor(Math.random() * a.element.height),
            vx: a.config.vx / 2 - Math.random() * a.config.vx,
            vy: a.config.vy / 2 - Math.random() * a.config.vy
        } : f(a.points[e], a), b.fillRect(c.x - a.config.width / 2, c.y - a.config.height / 2, a.config.width, a.config.height), a.points[e] = c;
        g(b, a, a.mouse), b.closePath();
    }

    function f(a, b) {
        var c = a;
        return a.x <= 0 || a.x >= b.element.width ? (c.vx = -c.vx, c.x += c.vx) : a.y <= 0 || a.y >= b.element.height ? (c.vy = -c.vy, c.y += c.vy) : c = {
            x: c.x + c.vx,
            y: c.y + c.vy,
            vx: c.vx,
            vy: c.vy
        }, c;
    }

    function g(a, b, c) {
        var d, e, f, dist;
        for (a = a || b.context, d = 0, e = b.config.count; e > d; d++) {
            for (b.points[d].max_conn = 0, f = 0; e > f; f++) d != f && (dist = Math.round(b.points[d].x - b.points[f].x) * Math.round(b.points[d].x - b.points[f].x) + Math.round(b.points[d].y - b.points[f].y) * Math.round(b.points[d].y - b.points[f].y), dist <= b.config.dist && b.points[d].max_conn < b.config.max_conn && (b.points[d].max_conn++, a.lineWidth = .5 - dist / b.config.dist, a.strokeStyle = 'rgba(' + b.config.stroke + ',' + (1 - dist / b.config.dist) + ')', a.beginPath(), a.moveTo(b.points[d].x, b.points[d].y), a.lineTo(b.points[f].x, b.points[f].y), a.stroke()));
            c && (dist = Math.round(b.points[d].x - c.x) * Math.round(b.points[d].x - c.x) + Math.round(b.points[d].y - c.y) * Math.round(b.points[d].y - c.y), dist > b.config.dist && dist <= b.config.e_dist && (b.points[d].x = b.points[d].x + (c.x - b.points[d].x) / 20, b.points[d].y = b.points[d].y + (c.y - b.points[d].y) / 20), dist <= b.config.e_dist && (a.lineWidth = 1, a.strokeStyle = 'rgba(' + b.config.stroke + ',' + (1 - dist / b.config.e_dist) + ')', a.beginPath(), a.moveTo(b.points[d].x, b.points[d].y), a.lineTo(c.x, c.y), a.stroke()));
        }
    }

    return c;
};
